import { AxiosContext } from '../contexts/axios/AxiosContext'
import { useContext } from 'react'

export const useAxios = () => {
    return useContext(AxiosContext).axios
}
